<template>
  <main-layout>
    <div class="head" slot="main-header">
      <Header />
    </div>
    <router-view></router-view>
    <div slot="main-footer">
      <Footer />
    </div>
  </main-layout>
</template>

<script>
import Header from "@/components/layout/Header";
import MainLayout from "@/components/layout/MainLayout";
import Footer from "@/components/layout/Footer";

export default {
  name: "MainLayoutContainer",
  components: {
    MainLayout,
    Header,
    Footer
  }
};
</script>
